import axios from 'axios'
//果园列表
export function getPlantList (data) {
  return axios.get(`/manage/plantation/list`, { params: data })
}
//新增修改果园
export function modifyPlant (data, action) {
  return axios.post(`/manage/plantation/${action}`, data)
}
//获取果园村围区域
export function getVillagesOrFields (data) {
  return axios.get(`/system/region/pageList`, { params: data })
}
//搜索果园村围区域列表
export function getSelectPlantationArea () {
  return axios.get(`/manage/plantation/selectPlantationArea`)
}
//删除果园
export function delPlantation (ids) {
  return axios.delete(`/manage/plantation/${ids}`)
}

//果园下拉列表
export function getDropPlantationList (data) {
  return axios.get(`/manage/plantation/queryDropDownBox`, { params: data })
}